(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["re-newsletter"] && !Shopify.designMode) return;
  try {
    const reWelcome=document.getElementById('re-welcome');
if(reWelcome&&typeof reWelcome.showModal==='function'){
 const read=key=>{try{return localStorage.getItem(key);}catch{return null;}};
 const write=(key,value)=>{try{localStorage.setItem(key,value);}catch{}};
 const success=reWelcome.querySelector('[data-re-welcome-success]');
 const error=reWelcome.querySelector('[data-re-welcome-error]');
 const signup=reWelcome.querySelector('form');signup?.addEventListener('submit',event=>{if(!signup.checkValidity()){event.preventDefault();event.stopImmediatePropagation();signup.reportValidity();}},true);
 let previousFocus;
 const open=()=>{if(reWelcome.open)return;previousFocus=document.activeElement;reWelcome.showModal();};
 const close=()=>{reWelcome.close();};
 reWelcome.querySelectorAll('[data-re-close]').forEach(button=>button.addEventListener('click',close));
 reWelcome.addEventListener('click',event=>{if(event.target===reWelcome)close();});
 reWelcome.addEventListener('close',()=>{write('re-club-dismissed',String(Date.now()));previousFocus?.focus();});
 if(success){write('re-club-joined','true');open();}
 else if(error){open();}
 else if(!read('re-club-joined')&&Date.now()-Number(read('re-club-dismissed')||0)>7*24*60*60*1000){setTimeout(()=>{if(!document.querySelector('dialog[open]'))open();},1800);}
}
  } catch(e) { console.error(e); }
})();

})();
